import React from 'react';
import { cx } from './cx';

// §4 radius-md, §1.3 micro type, §1.6 (single-word status chips may be caps).
//
// Tones split in two. The neutral/role tones are the semantic set from §2.2 —
// each means exactly one thing. The tag-* tones are the categorical set from
// §2.4 and mean identity, nothing more: they are fill-and-text only and must
// never appear on a spine, border, or focus state.
const BASE = [
  'inline-flex items-center justify-center',
  'rounded-radius-md px-space-3 py-space-1',
  'text-micro uppercase whitespace-nowrap',
  'transition-[background-color,color] duration-fast ease-standard',
].join(' ');

const TONES = {
  neutral: 'bg-carbon-700 text-carbon-200',
  accent: 'bg-accent text-carbon-950',
  grade: 'bg-grade text-carbon-950',
  caution: 'bg-caution text-carbon-950',
  danger: 'bg-danger text-carbon-950',
  live: 'bg-live text-carbon-950',
  moss: 'bg-tag-moss text-carbon-050',
  teal: 'bg-tag-teal text-carbon-050',
  indigo: 'bg-tag-indigo text-carbon-050',
  violet: 'bg-tag-violet text-carbon-050',
  magenta: 'bg-tag-magenta text-carbon-050',
};

export default function Chip({ tone = 'neutral', className, as: As = 'span', ...rest }) {
  return <As className={cx(BASE, TONES[tone], className)} {...rest} />;
}

export { TONES as CHIP_TONES };
